import React from "react";
import Draggable from "react-draggable";
import RoomRugCarpetItem from "./roomRugCarpetItem";

export default function RoomRugItem({ rug, rugKey, activeHandler }) {
  const preventDefault = (e) => {
    e = e || window.event;
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.returnValue = false;
  };

  const disableScroll = () => {
    document.addEventListener("wheel", preventDefault, {
      passive: false,
    });
  };

  const enableScroll = () => {
    document.removeEventListener("wheel", preventDefault, {
      passive: false,
    });
  };

  return (
    <Draggable
      bounds={{ top: -800, left: -800, right: 500, bottom: 400 }}
      key={rugKey}
    >
      {/* Draggable needs a div present before rending a component */}
      <div>
        <RoomRugCarpetItem
          rug={rug}
          rugKey={rugKey}
          activeHandler={activeHandler}
          enableScroll={enableScroll}
          disableScroll={disableScroll}
        />
      </div>
    </Draggable>
  );
}
